var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationMarkerEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 28,
    fill: "none",
    viewBox: "0 0 20 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4D4D4D",
    d: "M10 1.273c-4.832 0-8.75 3.988-8.75 8.909 0 5.036 5.48 13.182 7.766 16.06.508.64 1.46.64 1.968 0 2.286-2.878 7.766-11.024 7.766-16.06 0-4.92-3.918-8.91-8.75-8.91zM10 7c1.726 0 3.125 1.424 3.125 3.182 0 1.757-1.399 3.182-3.125 3.182s-3.125-1.425-3.125-3.182C6.875 8.424 8.274 7 10 7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMarkerEmpty);
export default __webpack_public_path__ + "static/media/location-marker-empty.5d3d473481da74408138b2fc1e1f87bf.svg";
export { ForwardRef as ReactComponent };